import { createSelector } from 'reselect';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import head from 'lodash/head';
import sortBy from 'lodash/sortBy';

export const configuratorOptions = createSelector(
  (state) => state.configurator,
  (configurator) => configurator.options,
);

export const configuratorOptionIdSelector = (optionName) => createSelector(
  [configuratorOptions],
  (options) => {
    const option = filter(options, (opt) => opt.internalName && opt.internalName.includes(optionName));
    if (!isEmpty(option)) {
      return option[0].id;
    }
    return null;
  }
);

export const configuratorChoices = createSelector(
  (state) => state.configurator,
  (configurator) => configurator.choices,
);

export const configuratorChoicesForCustomSelections = createSelector(
  configuratorChoices,
  (choices) => {
    const hasExtraConfigChoices = (tags) => tags.includes('extra-config-choices');
    const hasCustomRoomInfo = (tags) => tags.includes('custom-room-info');
    return filter(choices, ({ tags = [] }) => hasExtraConfigChoices(tags) || hasCustomRoomInfo(tags));
  }
);

export const configuratorGroups = createSelector(
  (state) => state.configurator,
  (configurator) => configurator.groups,
);

export const configuratorProductInfo = createSelector(
  (state) => state.configurator,
  (configurator) => configurator.productInfo,
);

export const selectParentSuperSkuId = createSelector(
  [configuratorOptionIdSelector('Parent_Super'), configuratorOptions, configuratorChoices],
  (parentOptionId, options, choices) => {
    const parentOptionChoiceId = options?.[parentOptionId]?.choices[0];
    if (parentOptionChoiceId) {
      const parentSku = choices[parentOptionChoiceId]?.shortLabel;
      return parentSku || null;
    }
    return null;
  }
);

export const orderedDependentOptionsSelector = (groupName) => createSelector(
  [configuratorGroups, configuratorOptions],
  (groups, options) => {
    const groupOptionIds = head(Object.values(groups).filter((group) => group.name === groupName));
    if (groupOptionIds) {
      const orderedGroupOptionIds = sortBy(groupOptionIds.options.map((val) => options[val]), 'sequence');
      return Object.values(orderedGroupOptionIds).map((oGOI) => oGOI.id);
    }
    return [];
  }
);
